import React from 'react';
import Form from 'react-bootstrap/Form';

const CropAreaInputTable = ({ listOfSelectedCrops, cropAreas, onCropAreaChange }) => {
    if (!listOfSelectedCrops.length) {
        return null;
    }

    const ValidateCropArea = (crop, event) => {
        if (event.target.value.length > 5)
            return;

        onCropAreaChange(crop.cropType, event.target.value)
    }

    return (
        <div className="row my-3">
            <div className="col-12">
                <h3 className='mb-3'>Crop areas</h3>
                <p className="text-muted">Enter the total area in hectares for each crop.</p>
                <div className="table-responsive">
                    <table className="table table-striped table-bordered align-middle mb-0">
                        <thead>
                            <tr>
                                <th scope="col">Crop</th>
                                <th scope="col">Area (ha)</th>
                            </tr>
                        </thead>
                        <tbody>
                            {listOfSelectedCrops.map((crop) => {
                                const cropLabel = crop.title ?? crop.cropType;
                                return (
                                    <tr key={crop.cropType}>
                                        <td>{cropLabel}</td>
                                        <td>
                                            <Form.Control
                                                type="number"
                                                min="0"
                                                step="0.01"
                                                placeholder="Enter Area"
                                                onKeyDown={(e) => {
                                                    if (["e", "E", "+", "-"].includes(e.key)) {
                                                        e.preventDefault();
                                                    }
                                                }}
                                                value={cropAreas?.[crop.cropType]}
                                                onChange={(event) => ValidateCropArea(crop, event)}
                                            />
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default CropAreaInputTable;
